var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 88393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2477",
    d: "M10.4169 16.8629C10.1698 16.0615 10.3092 15.0638 10.3092 14.2303C10.3092 13.9185 10.2737 13.6678 10.5007 13.4255C10.8713 13.0298 11.455 12.1035 12.0321 12.1035C15.1051 12.1035 18.178 12.1035 21.2509 12.1035C24.609 12.1035 27.9671 12.1035 31.3252 12.1035C33.4025 12.1035 35.478 12 37.5528 12C38.2577 12 38.9431 12.1035 39.6467 12.1035C40.192 12.1035 40.7044 12.2914 41.238 12.3104C42.6317 12.36 43.6395 12.404 44.5283 13.4715C44.8748 13.8878 44.8752 14.7476 44.8752 15.2592C44.8752 16.261 44.7676 17.2757 44.7676 18.2597C44.7676 22.2432 44.6599 26.2168 44.6599 30.2101C44.6599 31.2557 44.7676 32.3542 44.7676 33.3658C44.7676 34.1331 44.3648 34.564 43.9899 35.1764C43.5152 35.9518 41.8734 35.9007 41.1064 35.9007C39.4807 35.9007 37.8723 36.0042 36.2427 36.0042C29.1217 36.0042 22.0007 36.0042 14.8797 36.0042C13.9795 36.0042 12.8566 36.1358 12.0321 35.7398C11.2064 35.3431 10.9082 34.9482 10.5485 34.1418C10.4125 33.8368 10.4865 33.382 10.4109 33.0554C10.3089 32.6141 10.3063 32.0852 10.1477 31.6586C9.85039 30.8587 10.0939 29.6089 10.0939 28.7615C10.0939 27.8227 10.0939 26.8838 10.0939 25.945C10.0939 24.9096 10.4169 23.8537 10.4169 22.818C10.4169 20.7985 10.4169 18.779 10.4169 16.7594",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2478",
    d: "M20.1488 23.4829C19.5855 23.3293 18.9739 22.2685 18.9535 21.7165C18.9221 20.8683 18.7883 20.1184 18.9469 19.2462C19.3174 17.2081 22.1128 18.0594 23.3895 18.3431C25.1219 18.728 25.6075 21.3032 24.452 22.5267C23.36 23.683 21.9615 23.8415 20.3879 23.8415",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2479",
    d: "M15.4866 30.0567C15.0269 29.2686 16.7755 27.5535 17.4523 27.3074C18.7768 26.8258 19.9727 26.4707 21.4035 26.4707C23.6589 26.4707 27.4399 26.9462 27.4399 29.9371",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2480",
    d: "M30.5483 18.3418H34.732",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2481",
    d: "M30.3091 23.3633C33.1585 23.6007 36.053 23.4828 38.9154 23.4828",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2482",
    d: "M30.3091 26.7539C30.5509 26.9957 32.0978 26.7539 32.5005 26.7539C33.107 26.7539 33.7135 26.7539 34.3201 26.7539C35.8518 26.7539 37.3836 26.7539 38.9154 26.7539",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2483",
    d: "M15.2397 30.5508C17.7122 30.5508 20.2028 30.6012 22.6828 30.6012C23.2234 30.6012 23.7641 30.6012 24.3047 30.6012C24.7197 30.6012 25.222 30.5279 25.6157 30.6404C25.9218 30.7279 26.3708 30.6516 26.6858 30.6516C26.9954 30.6516 27.2797 30.7021 27.5934 30.7021",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aad60dce7daca7182ea7c9804e198b77.svg";
export { ForwardRef as ReactComponent };